import React from 'react';
import { Menu, LogOut } from 'lucide-react';
interface TopBarProps {
  title: string;
  onMenuToggle?: () => void;
}
export function TopBar({
  title,
  onMenuToggle
}: TopBarProps) {
  return <header className="sticky top-0 z-30 border-b px-4 sm:px-6 h-16 flex items-center justify-between" style={{
    backgroundColor: '#1e2d3d',
    borderColor: '#2a3d52'
  }} data-id="element-599">
      {/* Left: Mobile menu + page title */}
      <div className="flex items-center gap-4" data-id="element-600">
        <button onClick={onMenuToggle} className="md:hidden p-2 -ml-2 text-slate-300 hover:bg-white/10 rounded-lg transition-colors" data-id="element-601">
          <Menu className="w-5 h-5" data-id="element-602" />
        </button>
        <h2 className="text-base font-semibold text-white hidden md:block tracking-wide" data-id="element-603">
          {title}
        </h2>
        <span className="md:hidden font-bold text-white text-sm" data-id="element-604">
          ФАіСУ — Кабінет
        </span>
      </div>

      {/* Right: User block */}
      <div className="flex items-center gap-3 px-3 py-1.5 rounded-xl cursor-pointer transition-colors" style={{
      backgroundColor: 'rgba(255,255,255,0.04)'
    }} onMouseEnter={e => (e.currentTarget as HTMLDivElement).style.backgroundColor = 'rgba(255,255,255,0.09)'} onMouseLeave={e => (e.currentTarget as HTMLDivElement).style.backgroundColor = 'rgba(255,255,255,0.04)'} data-id="element-605">
        <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-sm flex-shrink-0" style={{
        background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
      }} data-id="element-606">
          МС
        </div>
        <div className="hidden sm:block min-w-0" data-id="element-607">
          <p className="text-sm font-semibold text-white leading-tight truncate" data-id="element-608">
            Микола Сало
          </p>
          <p className="text-xs truncate" style={{
          color: '#7fb3d3'
        }} data-id="element-609">
            UAF-2024-0847
          </p>
        </div>
        <LogOut className="w-4 h-4 flex-shrink-0" style={{
        color: '#7fb3d3'
      }} data-id="element-610" />
      </div>
    </header>;
}